var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 53,
    viewBox: "0 0 187 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.446 37.0787L109.926 15.8956H112.091L118.667 34.7557L125.36 15.8956H127.487L119.809 37.0787H117.446ZM132.423 15.8956H134.431V37H132.423V15.8956ZM132.383 8.65078H134.47V12.1157H132.383V8.65078ZM141.387 6.9577H143.395V37H141.387V6.9577ZM150.576 6.9577H152.584V37H150.576V6.9577ZM165.082 25.0303H172.208V22.1167C172.208 18.8617 170.384 17.2343 166.735 17.2343C164.478 17.2343 162.142 17.5755 159.727 18.258V16.3681C160.567 16.1581 161.774 15.9481 163.349 15.7381C164.898 15.5281 166.158 15.4231 167.129 15.4231C169.413 15.4231 171.158 16.0006 172.366 17.1555C173.6 18.3105 174.216 19.9773 174.216 22.156V37H172.484L172.326 34.0863C169.518 36.16 166.88 37.1969 164.412 37.1969C162.654 37.2756 161.092 36.7638 159.727 35.6613C158.388 34.5588 157.758 33.0889 157.837 31.2514C157.837 29.4927 158.427 28.0227 159.609 26.8415C160.79 25.6341 162.614 25.0303 165.082 25.0303ZM172.208 32.2751V26.684H165.121C163.441 26.684 162.155 27.0909 161.262 27.9046C160.396 28.6921 159.963 29.7814 159.963 31.1727C159.963 32.5376 160.396 33.5876 161.262 34.3226C162.129 35.0576 163.336 35.425 164.885 35.425C165.987 35.425 167.247 35.1232 168.665 34.5194C170.056 33.8895 171.237 33.1414 172.208 32.2751Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3696 33.7926C6.83371 33.7926 4.89402 30.799 4.89402 26.527C4.89402 21.5066 7.19181 19.3238 11.3696 19.3238C13.3989 19.3238 15.3982 19.6668 17.3379 20.3528V15.956C15.1595 15.27 12.8916 14.927 10.6236 14.927C5.461 14.927 0 17.4216 0 26.5582C0 35.7259 5.461 38.1893 10.6236 38.1893C12.8916 38.2205 15.1595 37.8463 17.3379 37.1603V32.7947C15.4281 33.4184 13.3989 33.7614 11.3696 33.7926Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6241 39.3742C61.7118 39.3742 66.934 36.5054 66.934 27.2129C66.934 19.1678 63.174 16.1118 59.1155 16.1118C56.6089 16.1118 54.4006 16.9538 52.1326 18.357V7.75488H47.3281V38.0957C50.0437 38.9064 52.819 39.343 55.6241 39.3742ZM62.04 27.5248C62.04 32.8258 60.1302 35.2269 55.7435 35.2269C54.5498 35.2269 53.3263 35.071 52.1625 34.8215V22.4108C54.2812 21.1323 56.1314 20.5398 57.5339 20.5398C60.4584 20.5398 62.04 22.785 62.04 27.5248ZM89.1063 33.6366C86.7787 34.4162 83.8841 35.0086 81.8847 35.0086C77.677 35.0086 75.2002 33.3871 75.1703 29.0839H89.4943V26.8075C89.4943 21.257 87.7038 16.1118 80.2434 16.1118C73.917 16.1118 70.1271 19.9785 70.1271 27.743C70.1271 35.7882 73.7976 39.3742 80.7507 39.3742C83.7647 39.3742 86.2415 38.8441 89.1063 37.9398V33.6366ZM75.1106 25.4667C75.1106 22.5043 76.7519 20.0721 79.9748 20.0721C83.9139 20.0721 84.5704 23.0032 84.6301 25.4667H75.1106ZM106.474 16.5172C103.132 16.7355 100.685 18.8559 98.3871 20.3839V16.642H93.8511V38.9065H98.6258V24.4688C101.461 23.1592 103.669 22.1301 106.474 21.6936V16.5172Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.002 7.38135H176.824V8.16092H178.495V12.6201H179.361V8.16092H181.002V7.38135ZM183.777 12.6512H184.792L186.105 8.47274H186.165V12.6512H187V7.41256H185.598L184.344 11.7158L183.061 7.41256H181.629V12.6512H182.464V8.47274H182.524L183.777 12.6512Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0959 15.021H20.7695L30.7068 44.3016L36.0186 41.7758L27.0959 15.021Z",
    fill: "url(#paint0_linear_1129_341)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0491 14.5847H44.3755L33.1551 52.2223H27.0674L38.0491 14.5847Z",
    fill: "url(#paint1_radial_1129_341)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1129_341",
    x1: 32.0779,
    y1: 31.7163,
    x2: 22.0284,
    y2: 33.9876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1129_341",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-17.0349 57.6919) rotate(-43.4431) scale(236.307 38.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33FFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#33FFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#5AD4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#CF55C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF22B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#D419B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#B011B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#920BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#7B06B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#6A03B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#6101B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#5E01BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E01BA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c923c997866117656b5a3fe02deed105.svg";
export { ForwardRef as ReactComponent };